import type { FetchFiltersRequest } from "features/filters/types/filters.types";
import type { IQueryParams } from "types";

// ── API Paths ─────────────────────────────────────────────────────────────────

export const apiPaths = {
  session: (slug: string) => `embed/${slug}/session`,
  bootstrap: (slug: string, visitor_uuid: string) =>
    `embed/${slug}/bootstrap/${visitor_uuid}`,
  property: (slug: string) => `embed/${slug}`,
  listings: (slug: string) => `embed/${slug}/listings`,
  filters: (slug: string) => `embed/${slug}/filters`,
  units: (slug: string) => `embed/${slug}/units`,
  engagement: (slug: string, unit_id: string) =>
    `embed/${slug}/engagement/${unit_id}`,
  save_filters: (slug: string) => `embed/${slug}/save_filters`,
  questionnaire: (slug: string) => `embed/${slug}/questionnaire`,
} as const;

// ── Query Keys ────────────────────────────────────────────────────────────────

export const queryKeys = {
  visitorUUID: () => ["visitorUUID"] as const,
  visitorSession: (slug: string) => ["visitor-session", slug] as const,
  bootstrap: (slug: string, visitor_uuid: string) =>
    ["bootstrap", slug, visitor_uuid] as const,
  property: (slug: string) => ["property", slug] as const,
  listings: (params: IQueryParams) => ["units", params] as const,
  filters: (params: FetchFiltersRequest) => ["filters", params] as const,
  unitsByIds: (slug: string, unitIds: number[]) =>
    ["unitsByIds", slug, unitIds] as const,
} as const;
